const SHOP_DATA = [
    {
        id: 1,
        name: 'Lorem Blue Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 39.99,
        imgUrl: 'https://i.ibb.co/jT6bY29/shirt9.jpg',
        tag: null,
        rating: 4.2,
        bestseller: true,
    },
    {
        id: 2,
        name: 'Brown Shoes',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shoes',
        price: 99.99,
        imgUrl: 'https://i.ibb.co/VBFP37X/shoes1.jpg',
        tag: "-10%",
        rating: 4.4,
        bestseller: true,
    },
    {
        id: 3,
        name: 'Lorem Backpack',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 39.99,
        imgUrl: 'https://i.ibb.co/DGJh8x3/bag7.jpg',
        tag: '-20%',
        rating: 4.3,
        bestseller: true,
    },
    {
        id: 4,
        name: 'Red Bunie',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 14,
        imgUrl: 'https://i.ibb.co/vwSNQcZ/hat1.jpg',
        tag: '-30%',
        rating: 4.9,
        bestseller: true,
    },
    {
        id: 5,
        name: 'Sky Blue Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 20.00,
        imgUrl: 'https://i.ibb.co/M7K7w8j/shirt5.jpg',
        tag: 'new',
        rating: 4.7,
        bestseller: true,
    },
    {
        id: 6,
        name: 'White Sneakers',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shoes',
        price: 70.00,
        imgUrl: 'https://i.ibb.co/GnGbCPn/shoes7.jpg',
        tag: 'new',
        rating: 3.8,
        bestseller: true,
    },
    {
        id: 7,
        name: 'Brown Backpack',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 27,
        imgUrl: 'https://i.ibb.co/RSqYVYb/bag8.jpg',
        tag: 'new',
        rating: 2.8,
        bestseller: false,
    },
    {
        id: 8,
        name: 'Green Lorem Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 75,
        imgUrl: 'https://i.ibb.co/GQcjmhQ/jacket8.jpg',
        tag: '-25%',
        rating: 3.6,
        bestseller: false,
    },
    {
        id: 9,
        name: 'Black Backpack',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 50.00,
        imgUrl: 'https://i.ibb.co/dKw8s0p/bag6.jpg',
        tag: 'new',
        rating: 4.8,
        bestseller: true,
    },
    {
        id: 10,
        name: 'Navy Blue Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 29.99,
        imgUrl: 'https://i.ibb.co/7b3RVhH/shirt2.jpg',
        tag: 'new',
        rating: 4.8,
        bestseller: true,

    },
    {
        id: 11,
        name: 'Brown Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 120,
        imgUrl: 'https://i.ibb.co/W3LCH34/jacket9.jpg',
        tag: 'new',
        rating: 4.2,
        bestseller: true,
    },
    {
        id: 12,
        name: 'Checkered Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 29.00,
        imgUrl: 'https://i.ibb.co/3SbZ1K0/shirt6.jpg',
        tag: 'new',
        rating: 2.3,
        bestseller: false,
    },
    {
        id: 13,
        name: 'Straw Hat',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 20,
        imgUrl: 'https://i.ibb.co/FsfzvLZ/hat2.jpg',
        tag: 'new',
        rating: 4.6,
        bestseller: true,
    },
    {
        id: 14,
        name: 'Red Sneakers',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shoes',
        price: 69.99,
        imgUrl: 'https://i.ibb.co/vwrg4Kg/shoes4.jpg',
        tag: 'new',
        rating: 4.9,
        bestseller: true,
    },
    {
        id: 15,
        name: 'Red Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 70,
        imgUrl: 'https://i.ibb.co/YpPkVmJ/jacket2.jpg',
        tag: 'new',
        rating: 3.7,
        bestseller: true,
    },
    {
        id: 16,
        name: 'Dioro Lorem Bag',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 34,
        imgUrl: 'https://i.ibb.co/yhM8hQB/bag1.jpg',
        tag: 'new',
        rating: 3.9,
        bestseller: false,
    },
    {
        id: 17,
        name: 'Lorem Sneakers',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shoes',
        price: 109.99,
        imgUrl: 'https://i.ibb.co/RjLQPBc/shoes2.jpg',
        tag: 'new',
        rating: 3.7,
        bestseller: false,
    },
    {
        id: 18,
        name: 'Lorem Backpack',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 35,
        imgUrl: 'https://i.ibb.co/1fKQKzC/bag5.jpg',
        tag: 'new',
        rating: 4.5,
        bestseller: true,
    },
    {
        id: 19,
        name: 'Brown Booties',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shoes',
        price: 20,
        imgUrl: 'https://i.ibb.co/C2qYsGS/shoes6.jpg',
        tag: 'new',
        rating: 4.1,
        bestseller: false,
    },
    {
        id: 20,
        name: 'Purple Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 29.00,
        imgUrl: 'https://i.ibb.co/Y8dx4Nx/shirt3.jpg',
        tag: 'new',
        rating: 3.8,
        bestseller: false,
    },
    {
        id: 21,
        name: 'Black Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 50,
        imgUrl: 'https://i.ibb.co/nCsBcN4/jacket1.jpg',
        tag: 'new',
        rating: 4.4,
        bestseller: true,
    },
    {
        id: 22,
        name: 'Striped Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 19.99,
        imgUrl: 'https://i.ibb.co/GTg6j4z/shirt4.jpg',
        tag: 'new',
        rating: 3.7,
        bestseller: true,
    },
    {
        id: 23,
        name: 'Leather Bag',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 20,
        imgUrl: 'https://i.ibb.co/d2sz0p2/bag4.jpg',
        tag: '-15%',
        rating: 4.7,
        bestseller: true,
    },
    {
        id: 24,
        name: 'Leather Pink Bag',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 20,
        imgUrl: 'https://i.ibb.co/93SX2ys/bag9.jpg',
        tag: 'new',
        rating: 4.6,
        bestseller: true,
    },
    {
        id: 25,
        name: 'Patterned Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 25.00,
        imgUrl: 'https://i.ibb.co/mT52tpk/shirt7.jpg',
        tag: 'new',
        rating: 3.9,
        bestseller: false,
    },
    {
        id: 26,
        name: 'Orange Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 15.00,
        imgUrl: 'https://i.ibb.co/W54NLdS/shirt1.jpg',
        tag: 'new',
        rating: 3.9,
        bestseller: false,
    },
    {
        id: 27,
        name: 'Yellow Striped Shirt',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shirt',
        price: 17.00,
        imgUrl: 'https://i.ibb.co/pjGmMwg/shirt8.jpg',
        tag: 'new',
        rating: 3.9,
        bestseller: false,
    },
    {
        id: 28,
        name: 'Pink Sneakers',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shoes',
        price: 125.00,
        imgUrl: 'https://i.ibb.co/0Btp8rs/shoes3.jpg',
        tag: 'new',
        rating: 4.2,
        bestseller: false,
    },
    {
        id: 29,
        name: 'Black Sneakers',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'shoes',
        price: 59.99,
        imgUrl: 'https://i.ibb.co/FDWPxYS/shoes5.jpg',
        tag: '-40%',
        rating: 4.2,
        bestseller: false,
    },
    {
        id: 30,
        name: 'Lorem Bag',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 59.99,
        imgUrl: 'https://i.ibb.co/LNNc7GL/bag3.jpg',
        tag: null,
        rating: 3.6,
        bestseller: false,
    },
    {
        id: 31,
        name: 'Tote Bag',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'bag',
        price: 15.99,
        imgUrl: 'https://i.ibb.co/h9Zk6zg/bag2.jpg',
        tag: null,
        rating: 4.1,
        bestseller: false,
    },
    {
        id: 32,
        name: 'Red Cap',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 12,
        imgUrl: 'https://i.ibb.co/ZGLy5R5/hat3.jpg',
        tag: null,
        rating: 4.1,
        bestseller: false,
    },
    {
        id: 33,
        name: 'Green Bunie',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 23,
        imgUrl: 'https://i.ibb.co/C67d8VP/hat4.jpg',
        tag: null,
        rating: 3.9,
        bestseller: true,
    },
    {
        id: 34,
        name: 'Burgundy Bunie',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 19,
        imgUrl: 'https://i.ibb.co/qCqznNj/hat5.jpg',
        tag: null,
        rating: 4.4,
        bestseller: true,
    },
    {
        id: 35,
        name: 'White Cap',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 14,
        imgUrl: 'https://i.ibb.co/CmmQKkh/hat6.jpg',
        tag: '-25%',
        rating: 4.4,
        bestseller: false,
    },
    {
        id: 36,
        name: 'Black Bunie',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 24,
        imgUrl: 'https://i.ibb.co/G2mqHGq/hat7.jpg',
        tag: '-25%',
        rating: 4.1,
        bestseller: false,
    },
    {
        id: 37,
        name: 'Brown Hat',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 33,
        imgUrl: 'https://i.ibb.co/sstPXTm/hat8.jpg',
        tag: 'new',
        rating: 4.3,
        bestseller: true,
    },
    {
        id: 38,
        name: 'Lorem Black Cap',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'hat',
        price: 15,
        imgUrl: 'https://i.ibb.co/HBffM1C/hat9.jpg',
        tag: 'new',
        rating: 4.7,
        bestseller: true,
    },
    {
        id: 39,
        name: 'Green Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 90,
        imgUrl: 'https://i.ibb.co/LpXXg95/jacket3.jpg',
        tag: 'new',
        rating: 4.7,
        bestseller: true,
    },
    {
        id: 40,
        name: 'Lorem Black Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 110,
        imgUrl: 'https://i.ibb.co/yYPhn4g/jacket4.jpg',
        tag: '-20%',
        rating: 3.7,
        bestseller: false,
    },
    {
        id: 41,
        name: 'Leather Black Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 200,
        imgUrl: 'https://i.ibb.co/5hpq1JG/jacket5.jpg',
        tag: 'new',
        rating: 4.4,
        bestseller: true,
    },
    {
        id: 42,
        name: 'Jeans Lorem Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 65,
        imgUrl: 'https://i.ibb.co/fkdV8Q8/jacket6.jpg',
        tag: null,
        rating: 3.6,
        bestseller: false,
    },
    {
        id: 43,
        name: 'Jeans Jacket',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta asperiores commodi velit quisquam similique, officiis incidunt corrupti unde dolor sed?',
        category: 'jackets',
        price: 105,
        imgUrl: 'https://i.ibb.co/fXC1vGx/jacket7.jpg',
        tag: 'new',
        rating: 4.6,
        bestseller: true,
    },

]

export default SHOP_DATA;

